import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, AlertCircle, Search, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-6 page-transition">
      <div className="w-full max-w-lg text-center">
        {/* 404 Illustration */}
        <div className="relative mb-8">
          <div className="text-[150px] font-black text-gradient leading-none opacity-20 select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="p-6 rounded-3xl bg-white card-shadow-lg border border-slate-100">
              <AlertCircle className="h-16 w-16 text-slate-400" />
            </div>
          </div>
        </div>

        {/* Message */}
        <div className="space-y-3 mb-8">
          <h1 className="text-3xl font-bold text-slate-900">Page not found</h1>
          <p className="text-slate-500 max-w-sm mx-auto">
            Sorry, we couldn't find the page you're looking for. It might have been moved or doesn't exist.
          </p>
        </div>

        {/* Path Display */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full card-shadow mb-8">
          <Search className="h-4 w-4 text-slate-400" />
          <code className="text-sm text-slate-600">{location.pathname}</code>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button
            onClick={() => navigate("/")}
            className="w-full sm:w-auto h-12 px-8 rounded-xl bg-gradient-to-r from-slate-900 to-slate-800 hover:from-slate-800 hover:to-slate-700 shadow-lg"
          >
            <Home className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="w-full sm:w-auto h-12 px-8 rounded-xl border-slate-200 hover:bg-slate-50"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go Back
          </Button>
        </div>

        {/* Help Text */}
        <p className="text-sm text-slate-400 mt-8">
          Need help? Contact support at{" "}
          <a href="mailto:support@chemsmart.edu" className="text-blue-500 hover:underline">
            support@chemsmart.edu
          </a>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
